var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',_vm._b({on:{"update":_vm.onUpdate},model:{value:(_vm.search),callback:function ($$v) {_vm.search=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"search"}},'b-form-input',{
    value: _vm.value,
    type: _vm.type,
    placeholder: _vm.placeholder,
    debounce: _vm.debounce
  },false))}
var staticRenderFns = []

export { render, staticRenderFns }